import CIMSTable from 'components/CIMSTable'
import { useGroupsContext } from './GroupsContext'
import { useColumns } from './hooks/useColumns'
import { useCreate } from './hooks/useCreate'
import { useEdit } from './hooks/useEdit'
import { useRemove } from './hooks/useRemove'
import { useRestore } from './hooks/useRestore'

const Groups: React.FC = () => {
  const { groups: data, fetching, refetch: onReload } = useGroupsContext()
  const columns = useColumns()
  const create = useCreate()
  const edit = useEdit()
  const remove = useRemove()
  const restore = useRestore()

  return (
    <CIMSTable
      records={data}
      loading={fetching}
      columns={columns}
      rowKey="id"
      actions={{
        header: { create, onReload },
        row: {
          edit,
          remove,
          restore,
          help: 'When Groups are removed, their connections are always disassociated and orders reset',
        },
      }}
    />
  )
}

export default Groups
